import "./style.css";
import moment from "moment";
import { BsCheck2All } from "react-icons/bs";

// Validates if the message is a pure emoji message to potentially increase font size (optional enhancement)
const isEmojiOnly = (string) => {
  const regex = /^(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])+$/;
  return regex.test(string);
};

const Messages = ({
  user,
  time_date,
  message,
  classs,
  isOwnMessage,
  sender,
  receiver,
  file,
  isLoading,
  progress,
}) => {
  const isDate = user === "date";

  if (isDate) {
    return <div className="message_message-date"><span>{message}</span></div>;
  }

  const avatarUrl = sender?.profile_image || "https://cdn-icons-png.flaticon.com/512/149/149071.png";

  const containerClass = isOwnMessage ? "message_container message_container_right" : "message_container message_container_left";
  const bubbleClass = isOwnMessage ? "message_bubble message_bubble_right" : "message_bubble message_bubble_left";
  const infoClass = isOwnMessage ? "message_info right_info" : "message_info left_info";

  return (
    <div className={containerClass}>
      <img
        src={avatarUrl}
        alt="User Avatar"
        className="message_avatar"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
        }}
      />

      <div className="flex flex-col max-w-[70%]">
        {!isOwnMessage && (
          <span className="sender_name">{sender?.full_name || sender?.owner_name || "User"}</span>
        )}

        <div className={bubbleClass}>
          {isLoading ? (
            <div className="relative">
              <img
                src={message}
                alt="Sending..."
                className="preview__image"
                style={{
                  filter: `blur(${(1 - progress / 100) * 10}px)`,
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center text-white font-bold bg-black/20 rounded-xl">
                {progress}%
              </div>
            </div>
          ) : file ? (
            <img src={message} alt="Shared Image" className="message__image" />
          ) : (
            <span>{message}</span>
          )}

          <div className={infoClass}>
            <span>{moment(time_date).format("LT")}</span>
            {/* {isOwnMessage && !isLoading && <BsCheck2All size={16} />} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Messages;
